import { DASHBOARD_PANELS_PAGE } from "../constants/app";
import { Page } from "../types/core";
import { SafeGuardPanel } from "../types/safeGuard";

export const convertToSlug = (text: string) => {
  return text
    .toLowerCase()
    .replace(/[\s]+|[^\w\-]+|[\-]{2,}|(^-+)|(-+$)/g, (match, g1, g2) => {
      if (/\s/.test(match)) return '-';
      if (/[\-]{2,}/.test(match)) return '-';
      return ''; 
    });

};

export const getPanelPage = (panel: SafeGuardPanel): Page => { 
  return {
    id: panel._id,
    name: panel.name,
    icon: 'description',
    route: `/dashboard/${convertToSlug(panel.name)}`,
    navKey: `${convertToSlug(panel.name)}`,
    parentId: DASHBOARD_PANELS_PAGE.id,
    panelUrl: panel.url,
  };
}